// Redirect legacy query URLs and slashless paths before S3/CloudFront can leak the deploy commit hash.
const LEGACY_SECTION_TO_PATH = {
  email: '/branding/',
  overview: '/overview/',
  activity: '/analytics/',
  button: '/unlock-button/',
  'unlock-flow': '/unlock-button/',
  checkout: '/unlock-page/',
  products: '/unlock-page/',
  'product-catalog': '/unlock-page/'
}

const LEGACY_TAB_TO_PATH = {
  setup: '/unlock-button/',
  button: '/unlock-button/',
  email: '/branding/',
  branding: '/branding/',
  page: '/unlock-page/',
  success: '/unlock-success/'
}

const PATH_REDIRECTS = {
  '/button': '/unlock-button/',
  '/button/': '/unlock-button/',
  '/checkout-button': '/unlock-button/',
  '/checkout-button/': '/unlock-button/',
  '/unlock-flow': '/unlock-button/',
  '/unlock-flow/': '/unlock-button/',
  '/unlock-flow/email': '/branding/',
  '/unlock-flow/email/': '/branding/',
  '/unlock-flow/branding': '/branding/',
  '/unlock-flow/branding/': '/branding/',
  '/unlock-flow/page': '/unlock-page/',
  '/unlock-flow/page/': '/unlock-page/',
  '/unlock-flow/success': '/unlock-success/',
  '/unlock-flow/success/': '/unlock-success/',
  '/checkout': '/unlock-page/',
  '/checkout/': '/unlock-page/',
  '/checkout/email': '/branding/',
  '/checkout/email/': '/branding/',
  '/checkout/branding': '/branding/',
  '/checkout/branding/': '/branding/',
  '/checkout/page': '/unlock-page/',
  '/checkout/page/': '/unlock-page/',
  '/checkout/features': '/unlock-page/features/',
  '/checkout/features/': '/unlock-page/features/',
  '/checkout/usage': '/trial-usage/',
  '/checkout/usage/': '/trial-usage/',
  '/checkout/text': '/unlock-page/text/',
  '/checkout/text/': '/unlock-page/text/',
  '/checkout/success': '/unlock-success/',
  '/checkout/success/': '/unlock-success/',
  '/checkout-page': '/unlock-page/',
  '/checkout-page/': '/unlock-page/',
  '/checkout-page/features': '/unlock-page/features/',
  '/checkout-page/features/': '/unlock-page/features/',
  '/checkout-page/usage': '/trial-usage/',
  '/checkout-page/usage/': '/trial-usage/',
  '/checkout-page/text': '/unlock-page/text/',
  '/checkout-page/text/': '/unlock-page/text/',
  '/products': '/unlock-page/',
  '/products/': '/unlock-page/',
  '/product-catalog': '/unlock-page/',
  '/product-catalog/': '/unlock-page/',
  '/product-catalog/features': '/unlock-page/features/',
  '/product-catalog/features/': '/unlock-page/features/',
  '/product-catalog/usage': '/trial-usage/',
  '/product-catalog/usage/': '/trial-usage/',
  '/product-catalog/text': '/unlock-page/text/',
  '/product-catalog/text/': '/unlock-page/text/',
  '/unlock-page/usage': '/trial-usage/',
  '/unlock-page/usage/': '/trial-usage/'
}

const url = new URL(window.location.href)
const legacySection = url.searchParams.get('section')

if (legacySection) {
  const path = LEGACY_SECTION_TO_PATH[legacySection]
  if (path) {
    url.searchParams.delete('section')
    const target = new URL(path, url.origin)
    target.search = url.search
    target.hash = url.hash
    window.location.replace(target.toString())
  }
} else if (url.searchParams.has('tab')) {
  const legacyTab = url.searchParams.get('tab')
  const path = LEGACY_TAB_TO_PATH[legacyTab] || LEGACY_TAB_TO_PATH.button
  url.searchParams.delete('tab')
  const target = new URL(path, url.origin)
  target.search = url.search
  target.hash = url.hash
  window.location.replace(target.toString())
} else {
  const pathRedirect = PATH_REDIRECTS[url.pathname]
  if (pathRedirect) {
    window.location.replace(`${pathRedirect}${url.search}${url.hash}`)
  } else {
    const { pathname, search, hash } = window.location
    const segment = pathname.split('/').pop() || ''

    if (pathname !== '/' && !pathname.endsWith('/') && !segment.includes('.')) {
      window.location.replace(`${pathname}/${search}${hash}`)
    }
  }
}
